import { makeStyles } from "@material-ui/styles";
import Table from "../../Common/Box/Table";
import initialData from "../../../data/initialData.json";
import useCsvDownload from "../../../hooks/useCsvDownload";
import { formatNumber } from "../../../utilities";

const number = 4;

const format = (n) =>
  formatNumber(n, {
    prefix: "$",
    significantDigits: 3,
  });

const useStyles = makeStyles((theme) => ({
  changeGroupBoundary: {
    borderLeft: `1px solid ${theme.table.border.primary}`,
  },
  nameGroupBoundary: {
    borderRight: `1px solid ${theme.table.border.primary}`,
  },
  table: {
    borderCollapse: "collapse",
    fontSize: theme.table.fontSize,
    "& tbody tr": {
      borderTop: `1px solid ${theme.table.border.primary}`,
    },
    "& tbody tr:first-child": {
      borderTop: `1px solid ${theme.table.border.secondary}`,
    },
    "& tbody tr:last-child": {
      fontWeight: "bold",
      borderTop: `1px solid ${theme.table.border.secondary}`,
    },
    "& td": {
      padding: theme.table.cellPadding,
      textAlign: "right",
      whiteSpace: "nowrap",
    },
    "& td:first-child": {
      textAlign: "left",
    },
    "& th": {
      padding: theme.table.cellPadding,
      whiteSpace: "nowrap",
    },
    "& tr:last-child td:not(:first-child)": {
      minWidth: "6rem",
    },
  },
  total: {
    backgroundColor: theme.palette.area.background,
  },
}));

const Component = () => {
  const downloadCsv = useCsvDownload();

  const classes = useStyles();

  const handleCsvDownload = () => {
    downloadCsv("/apac/tables/4/csv", `apac_t${number}.csv`);
  };

  const data = initialData["apac_t4"];

  return (
    <Table
      key="APAC_t4"
      number={number.toString()}
      title="Cost of Abortion and PAC Supplies by Method"
      subtitle="By Income Group, 2019"
      onDownloadCsv={handleCsvDownload}
    >
      <table className={classes.table}>
        <thead>
          <tr>
            <th />
            <th className={classes.total} />
            <th colSpan={2} />
            <th colSpan={2} className={classes.changeGroupBoundary}>
              Within Medical
            </th>
          </tr>
          <tr>
            <th />
            <th className={classes.total}>Total</th>
            <th>
              Surgical:
              <br />
              Vacuum aspiration
            </th>
            <th>Medical: All</th>
            <th className={classes.changeGroupBoundary}>Misoprostol</th>
            <th>Mifepristone</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.incomeGroup}>
              <td>{item.incomeGroup}</td>
              <td className={classes.total}>{format(item.total)}</td>
              <td>{format(item.mva)}</td>
              <td>{format(item.medical)}</td>
              <td className={classes.changeGroupBoundary}>
                {format(item.miso)}
              </td>
              <td>{format(item.mife)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Table>
  );
};

export default Component;
